import { LeadsWidgetForm } from '@sendpayments/react-shared/components/forms/LeadsWidgetForm';
import React, { useState } from 'react';
import leadsWidgetFormSubmit from './leadsWidgetFormSubmit';
import leadsWidgetValidation from './leadsWidgetValidation';
import * as styles from './LeadsWidget.module.less';

/**
 *
 * @param {{
 *  config: {Object} config
 * }} param0
 * @example http://localhost:9000/?showDetailForm=true&referral=cool
 */
const LeadsWidget = ({ config = {} }) => {
  const [showDetailForm, setShowDetailForm] = useState(
    config.alwaysShowDetailForm ? -1 : 0
  );

  const handleLeadsWidgetChange = (values) => {
    const currentSliderIndex = config.configuredTransferValues.indexOf(
      values.transferValue
    );
    const minimumSliderIndex = config.configuredTransferValues.indexOf(
      config.showDetailFormMinimumValue
    );
    if (
      currentSliderIndex >= minimumSliderIndex || config.alwaysShowDetailForm
        ? -1
        : 0
    ) {
      setShowDetailForm(true);
    } else {
      setShowDetailForm(false);
    }
  };

  return (
    <div className={styles.div}>
      <LeadsWidgetForm
        fullForm={showDetailForm}
        referral={config.referralCode.length > 0}
        referralCode={config.referralCode}
        transferValues={config.configuredTransferValues}
        defaultIndex={config.transferValueIndex}
        defaultFromCurrency={config.fromCurrency}
        defaultToCurrency={config.toCurrency}
        slider={config.slider}
        validate={(formValues) =>
          leadsWidgetValidation(formValues, showDetailForm)
        }
        onChange={handleLeadsWidgetChange}
        onSubmit={(formValues, { setSubmitting }) =>
          leadsWidgetFormSubmit(
            config.affiliateId,
            formValues,
            showDetailForm,
            setSubmitting,
            config.trackingId,
            config.metadata
          )
        }
      />
    </div>
  );
};

export default LeadsWidget;
